import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { SortableHandle } from 'react-sortable-hoc';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import FormikField from '@components/form/FormikField';

const DragHandle = SortableHandle(() => <i className="fas fa-grip-vertical mr-3" style={{ cursor: 'move' }} />);

const ParcelCard = ({
  file,
  sortIndex,
  validateFigField,
  fieldsList,
}) => {
  const { values, setValues } = useFormikContext();
  const value = values?.Parcels[file.uid];

  const handleDelete = () => {
    // update deleted entry
    const updated = {
      ...values.Parcels,
      [file.uid]: {
        ...file,
        IsDeleted: true,
      },
    };
    // recalculate sort order
    let index = 0;
    Object.entries(updated).forEach(([k]) => {
      if (!updated[k].IsDeleted) {
        updated[k].SortOrder = index + 1;
        index += 1;
      }
    });
    // set formik state
    setValues({
      ...values,
      Parcels: updated,
    });
  };

  return (
    <>
      <Card id={file.uid} className="mb-g">
        <Card.Header className="pr-3 d-flex align-items-center flex-wrap">
          <div className="card-title">
            <DragHandle />
            {sortIndex + 1}
          </div>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-delete-parcel-${file.uid}`} style={{ margin: 0 }}>Delete Parcel</Tooltip>}
          >
            <Button
              name="btnDeleteParcel"
              onClick={handleDelete}
              className="ml-auto"
              size="sm"
            >
              <i className="far fa-trash-alt" aria-hidden="true" />
            </Button>
          </OverlayTrigger>
        </Card.Header>
        <Card.Body>
          {fieldsList && fieldsList.map(field => (
            <FormikField
              key={field.RowID}
              validateFigField={validateFigField}
              {...field}
              value={value[field.FieldName]}
              name={field.FieldName}
              FieldName={`Parcels.[${file.uid}].${field.FieldName}`}
            />
          ))}
        </Card.Body>
      </Card>
    </>
  );
};

ParcelCard.propTypes = {
  file: PropTypes.shape(),
  sortIndex: PropTypes.number.isRequired,
  validateFigField: PropTypes.func,
  fieldsList: PropTypes.arrayOf(PropTypes.shape()),
};

export default ParcelCard;
